module.exports = __webpack_public_path__ + "/login_ui/img/bi-77e1868a7250fb6ca4dbadb29125542f.svg";